import { Link } from "react-router-dom";
import { LEGAL_LINKS } from "@/components/LegalLayout";
import { openConsentSettings } from "@/lib/consent";
import { InstallApp } from "@/lib/pwa";
import { NewsletterSignup } from "@/components/NewsletterSignup";

export const Footer = () => (
  <footer className="relative mt-24 overflow-hidden bg-ocean text-shell grain" data-testid="site-footer">
    <div className="relative mx-auto grid max-w-[1400px] gap-12 px-5 py-16 md:grid-cols-12 md:px-10">
      <div className="md:col-span-5">
        <p className="font-display text-3xl">WattNu <span className="italic text-terracotta">Ostfriesland</span></p>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-shell/70">
          Dein Begleiter für Küste, Inseln und Fehnland – für alle, die hier leben oder Urlaub machen.
        </p>
        <div className="mt-5"><InstallApp className="text-shell" /></div>
      </div>
      <div className="md:col-span-3">
        <p className="eyebrow text-sage">Entdecken</p>
        <ul className="mt-4 space-y-2 text-sm text-shell/80">
          <li><Link to="/entdecken" className="hover:text-white">Orte & Aktivitäten</Link></li>
          <li><Link to="/veranstaltungen" className="hover:text-white">Veranstaltungen</Link></li>
          <li><Link to="/wochenende" className="hover:text-white" data-testid="footer-weekend-link">Dieses Wochenende</Link></li>
          <li><Link to="/karte" className="hover:text-white">Karte</Link></li>
          <li><Link to="/wetter" className="hover:text-white">Wetter & Gezeiten</Link></li>
          <li><Link to="/orte" className="hover:text-white">Orte</Link></li>
          <li><Link to="/inseln" className="hover:text-white">Inseln</Link></li>
          <li><Link to="/anreise" className="hover:text-white">Fähren & Anreise</Link></li>
          <li><Link to="/wattfuehrer" className="hover:text-white" data-testid="footer-watt-guides-link">Wattführer</Link></li>
        </ul>
      </div>
      <div className="md:col-span-4">
        <NewsletterSignup dark compact testid="footer-newsletter" />
        <p className="eyebrow mt-10 text-sage">Offene Datenquellen</p>
        <p className="mt-4 text-sm leading-relaxed text-shell/70">
          Wetter & Meer: <a className="underline" href="https://open-meteo.com" target="_blank" rel="noreferrer">Open-Meteo</a> (CC BY 4.0) ·
          Warnungen: DWD · Pegel: WSV ·
          Karte & Orte: © <a className="underline" href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer">OpenStreetMap</a>-Mitwirkende.
          Gezeitenwerte sind Modellwerte und nicht für die Navigation geeignet. <Link to="/quellen" className="underline">Alle Quellen</Link>
        </p>
      </div>
    </div>
    <div className="relative border-t border-white/10">
      <div className="mx-auto flex max-w-[1400px] flex-wrap items-center gap-x-6 gap-y-2 px-5 py-5 text-xs text-shell/70 md:px-10" data-testid="footer-legal">
        <span>© {new Date().getFullYear()} WattNu Ostfriesland</span>
        {LEGAL_LINKS.map((l) => <Link key={l.to} to={l.to} className="hover:text-white" data-testid={`footer-link-${l.to.slice(1)}`}>{l.label}</Link>)}
        <button onClick={openConsentSettings} className="hover:text-white" data-testid="footer-cookie-settings">Cookie-Einstellungen</button>
      </div>
    </div>
  </footer>
);
